// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { isNullOrUndefined } from '../../util/Helpers'

/**
 * Provides a method used to validate an object.
 */
export class ObjectNotNullOrUndefinedRule {
  /**
   * Checks whether an object is null or undefined.
   * @param value The value to be validated.
   * @param name The parameter name. Defaults to "value".
   * @return If `value` is invalid, an exception; otherwise, undefined.
   */
  public static checkRule(value: any, name: string = this.parameterName): Error {
    if (isNullOrUndefined(value)) {
      return Error(`${name} cannot be null or undefined`)
    }
    return undefined
  }
  private static readonly parameterName = 'value'
}
